// Fixed rate card line items shown on every talent's profile.
export const RATE_CARD_ITEMS = [
  { id: 'ig_reel', label: 'IG Reel' },
  { id: 'tiktok', label: 'TikTok' },
  { id: 'ig_reel_tiktok_repost', label: 'IG Reel & TikTok Repost' },
  { id: 'ig_story_set', label: 'IG Story Set (3 Frames)' },
  { id: 'ig_reel_ig_story_set', label: 'IG Reel + IG Story Set' },
  { id: 'yt_short', label: 'YT Short' },
  { id: 'ig_reel_tiktok_yt_short_repost', label: 'IG Reel & TikTok & YT Short Repost' },
  { id: 'yt_dedicated', label: 'YT Dedicated' },
  { id: 'yt_integrated', label: 'YT Integrated' },
  { id: 'ugc_video', label: 'UGC Video' },
  { id: 'usage_30_days', label: '30 Days Usage' },
];
